export enum AuthNextAction {
  SETUP_TOTP = 'SETUP_TOTP',
  VALIDATE_TOTP = 'VALIDATE_TOTP',
}

export interface Login {
  mfaToken: string;
  nextAction: AuthNextAction;
  totpUri?: string;
}

export interface FormValues {
  email: string;
  password: string;
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'IN ACTIVE',
}

export enum MFA {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
}
export interface CurrentUser {
  status: UserStatus;
  mfa: MFA;
  profile: {
    userId: string;
    firstName: string;
    lastName: string;
    avatarImg: string;
    id: string;
  };
  email: string;
  password: string;
  profileId: string;
  employeeRoleTemplateId: string;
  id: string;
}
